<template>
  <div id="index-work-license-detalis">
    <!-- 学生端上岗证详情 -->
    <div class="content" v-if="list.length > 0">
      <div
        class="item"
        v-for="(item, index) in list"
        :key="index"
        @click="showDetails(item)"
      >
        <div class="jl" @click.stop="showRecord(item)">查看记录</div>
        <div class="icon">
          <i class="iconfont icon-shanggangzhengguanli"></i>
        </div>
        <div class="line">
          <div class="title">编号:</div>
          <div class="value">{{ item.number }}</div>
        </div>
        <div class="line">
          <div class="title">专业:</div>
          <div class="value">{{ item.professional }}</div>
        </div>
        <div class="line">
          <div class="title">工种/岗位:</div>
          <div class="value">{{ item.station }}</div>
        </div>
        <div class="line">
          <div class="title">发证日期:</div>
          <div class="value">{{ item.time }}</div>
        </div>
        <div class="line">
          <div class="title">剩余分数:</div>
          <div class="value">{{ item.surplusGrade }}</div>
        </div>
      </div>
    </div>
    <div class="content" v-else>
      <diy_nothing :tip="'暂无数据!!! 请先参加上岗证考核!!!'"></diy_nothing>
    </div>
    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          number: "上岗证编号",
          professional: "专业",
          station: "工种/岗位",
          time: "发证日期",
          surplusGrade: "剩余分数",
        },
      ],
      dialogData: {
        flag: false,
        title: "上岗证预览",
        width: "40%",
        tempData: {},
        dialogData: [],
        buttonList: [
          { text: "确定", active: "makesure_choose_import_type" },
          { text: "取消", active: "cancel" },
        ],
      },
    };
  },
  methods: {
    /**
     * 获取当前学员所获得的所有上岗证
     */
    async getWorkLicenseDetailsByUserId() {
      try {
        let resultData = await this.$request({
          url: "/workLicense/getAllWorkLicenseListByUser",
          method: "post",
          data: {},
        });
        this.list = resultData;
      } catch (error) {
        this.$message({
          message: error.message,
          type: "warning",
          duration: 1000,
        });
      }
    },
    /**
     * 查看当前上岗证详情
     */
    showDetails(item) {
      // 查看具体学员的上岗证信息
      this.dialogData.title = "上岗证预览";
      this.dialogData.width = "550px";
      this.dialogData.dialogData = [
        { type: "work_license", value: item.workId },
      ];
      this.dialogData.buttonList = [{ text: "关闭", active: "cancel" }];
      this.dialogData.flag = true;
    },
    /**
     * 查看扣分记录
     */
    async showRecord(item) {
      let resultData = await this.$request({
        url: "/workLicense/showUserWorkLicenseDeductRecord",
        method: "post",
        data: { workId: item.workId },
      });
      this.dialogData.width = "30%";
      this.dialogData.title = "上岗证扣分";
      this.dialogData.width = "40%";
      this.dialogData.dialogData = [
        {
          value: resultData,
          type: "deduct_record",
        },
      ];
      this.dialogData.buttonList = [{ text: "关闭", active: "cancel" }];
      this.dialogData.flag = true;
    },
    /**
     * 弹出框操作事件
     */
    dialogOper(active) {
      switch (active) {
        case "cancel":
          this.colseDialog();
          break;

        default:
          break;
      }
    },
    /**
     * 弹出框关闭事件
     */
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  mounted() {
    this.getWorkLicenseDetailsByUserId();
  },
};
</script>

<style lang="less" scoped>
#index-work-license-detalis {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px 15px;
  box-sizing: border-box;
  > .content {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    border-radius: 10px;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    overflow-y: auto;
    > .item {
      width: 240px;
      height: 300px;
      display: flex;
      flex-direction: column;
      margin: 10px;
      border: 1px solid #cecece;
      border-radius: 3px;
      cursor: pointer;
      position: relative;
      > .jl {
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 13px;
        color: #2962ad;
        cursor: pointer;
        transition: 0.3s;
        &:hover {
          color: #439ef3;
        }
      }
      > .icon {
        width: 240px;
        height: 130px;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          font-size: 80px;
          color: #bebebe;
        }
      }
      > .line {
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        // justify-content: center;
        font-size: 14px;
        margin-bottom: 8px;
        > .title {
          width: 40%;
          height: auto;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-right: 4px;
        }
        > .value {
          width: 0;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }
      }
    }
  }
}
</style>